"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALERTS = void 0;
const react_1 = require("react");
const services_1 = require("modules/app/services");
const viewCreateDrippingAlertsSchema_1 = __importDefault(require("modules/app/services/datahubEvents/dripping/viewCreateDrippingAlertsSchema"));
exports.ALERTS = {
    MIN_SCORE: {
        name: 'MIN_SCORE',
        text: 'dripping_2.new.release_and_expiration.release.items.quiz.min_score_required',
        type: 'info',
        icon: 'exclamation-circle',
        persistDismiss: false
    },
    HAS_DRIPPING: {
        name: 'HAS_DRIPPING',
        text: 'dripping_2.new.release_and_expiration.release.items.quiz.has_dripping',
        type: 'warning',
        icon: 'exclamation-triangle',
        persistDismiss: false
    },
    NOT_PUBLISHED: {
        name: 'NOT_PUBLISHED',
        text: 'dripping_2.new.release_and_expiration.release.items.quiz.not_published_v2',
        type: 'warning',
        icon: 'exclamation-triangle',
        persistDismiss: false
    },
    AVAILABLE_CLASSES: {
        name: 'AVAILABLE_CLASSES',
        text: 'dripping_2.new.release_and_expiration.release.items.quiz.available_classes',
        type: 'warning',
        icon: 'exclamation-triangle',
        persistDismiss: true
    }
};
const getAlertKey = (alertName) => {
    return `clubAdmin:drippingByQuizAlerts:${alertName}`;
};
const useDrippingByQuizAlerts = (quiz) => {
    const [alertConfigs, setAlertConfigs] = (0, react_1.useState)([]);
    const dismissAlert = (0, react_1.useCallback)((alertName) => {
        if (exports.ALERTS[alertName].persistDismiss) {
            localStorage.setItem(getAlertKey(alertName), 'true');
        }
        setAlertConfigs((previousValue) => previousValue.filter((ac) => ac.name !== alertName));
    }, []);
    (0, react_1.useEffect)(() => {
        const updatedAlertConfigs = [];
        const addAlert = (alertName) => {
            if (!localStorage.getItem(getAlertKey(alertName))) {
                updatedAlertConfigs.push(exports.ALERTS[alertName]);
            }
        };
        if (quiz) {
            if (!quiz.published) {
                addAlert('NOT_PUBLISHED');
            }
            else {
                if (quiz.minimumScorePercent === 0) {
                    addAlert('MIN_SCORE');
                }
                if (quiz.hasDripping) {
                    addAlert('HAS_DRIPPING');
                }
            }
            setAlertConfigs(updatedAlertConfigs);
            if (updatedAlertConfigs.length > 0) {
                services_1.DatahubEventsService.sendEvent({
                    schema: new viewCreateDrippingAlertsSchema_1.default({
                        arrivedFrom: services_1.ArrivedFrom.DRIPPING_FORM,
                        alerts: updatedAlertConfigs.map((a) => a.name)
                    })
                });
            }
        }
    }, [quiz]);
    return { alertConfigs, dismissAlert };
};
exports.default = useDrippingByQuizAlerts;
